import { render } from "./ModalResident.vue?vue&type=template&id=e39b5e16&ts=true"
import script from "./ModalResident.vue?vue&type=script&lang=ts"
export * from "./ModalResident.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__